import { Component, forwardRef, Input, Output } from '@angular/core';
import { ControlValueAccessor, FormsModule, NG_VALUE_ACCESSOR } from '@angular/forms';
import { CssMediaService } from '../../lib/media.service';
import { NgClass } from '@angular/common';

export enum DockTitle {
    top,
    left,
    right,
    bottom,
}

@Component({
    selector: 'se-sliderbutton',
    templateUrl: './se-sliderbutton.component.html',
    styleUrls: ['./se-sliderbutton.component.css', './se-sliderbutton.component.mobile.css'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => SeSliderButtonComponent),
            multi: true,
        },
    ],
    standalone: true,
    imports: [NgClass, FormsModule],
})
export class SeSliderButtonComponent implements ControlValueAccessor {
    // events

    @Input()
    dock = DockTitle.top;

    // Data Members
    @Input()
    title: string;
    @Input()
    min: number;
    @Input()
    max: number;
    @Input()
    step: number;

    constructor(public cssMediaService: CssMediaService) {}

    private _value: number;
    get value() {
        return this._value;
    }
    @Input()
    set value(value: number) {
        if (this._value == value) return;

        this._value = value;
        this.propagateChange(value);
    }

    // Constructor

    @Output()
    propagateChange = (_: any) => {
        /* This is intentional */
    };

    // private functions

    // public functions

    writeValue(obj: any): void {
        if (obj !== undefined) this.value = obj;
    }

    registerOnChange(fn: any): void {
        this.propagateChange = fn;
    }

    registerOnTouched(fn: any): void {
        /* This is intentional */
    }

    setDisabledState(isDisabled: boolean): void {
        /* This is intentional */
    }
}
